<template>
  <div :id="data.id" class="bg-gray-lighten3 py-10 md:py-14">
    <div class="container overflow-hidden text-slate">
      <UiSectionTitle
        v-if="data.title"
        :title="data.title"
        class="title mb-8 flex whitespace-pre-line text-3xl uppercase leading-none text-slate md:justify-center md:text-center md:text-[3.5rem]"
      />

      <div v-if="data.items && data.items.length">
        <swiper-container
          ref="swiperEl"
          init="false"
          class="apps-swiper !overflow-visible pb-11"
        >
          <div slot="container-end" class="swiper-scrollbar"></div>

          <swiper-slide
            v-for="(item, i) in data.items"
            :key="i"
            class="group flex w-[241px] flex-col overflow-hidden rounded-lg"
          >
            <div
              v-lazy-background="getAssetUrl(item.image)"
              class="bg-neutral bg-cover bg-center bg-no-repeat pt-[83%] md:h-[364px] md:pt-0"
            ></div>

            <div
              class="flex w-full flex-grow flex-col items-center bg-white px-6 pb-6 pt-8 text-center text-lg md:px-6 md:pb-8 md:text-xl"
            >
              <div
                v-if="item.name"
                class="title mb-2 uppercase leading-none group-hover:text-blue"
              >
                <span class="whitespace-pre-line" v-html="item.name" />
              </div>

              <div
                class="mx-[0.1rem] mb-6 text-sm leading-[1.225rem] text-slate md:mx-0"
              >
                <span class="md:whitespace-pre-line" v-html="item.text" />
              </div>

              <div
                v-if="item.button && item.button.text"
                class="mt-auto w-full"
              >
                <UiButton
                  size="md"
                  :block="!isDesktop"
                  :to="item.button.link"
                  :target="item.button.target"
                >
                  <span v-html="item.button.text" />
                </UiButton>
              </div>
            </div>
          </swiper-slide>
        </swiper-container>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useBreakpoint, useMediaAsset, useSwiperElement } from '~/composables';

interface Props {
  data?: any;
}

withDefaults(defineProps<Props>(), {
  data: () => ({}),
});

const { getAssetUrl } = useMediaAsset();
const { isBiggerThanBreakpoint: isDesktop } = useBreakpoint('md');

const swiperOptions = {
  observer: true,
  slidesPerView: 'auto',
  spaceBetween: 16,
  scrollbar: {
    el: '.swiper-scrollbar',
    draggable: true,
    dragSize: 180,
    snapOnRelease: true,
  },
  breakpoints: {
    1024: {
      slidesPerView: 3,
    },
  },
};

const swiperEl = useSwiperElement(swiperOptions);
</script>
